
interface Config {
   apiBaseUrl: string;
   appVersion: string;
   versionUrl: string;
}

// 
const config: Config = window['appGlobals'];

// console.log('config', config);

export { config };
